export default __webpack_public_path__ + "static/media/unfold-btn.ca89c0b2.svg";